<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'estatal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <!--  -->
                    <h1 class="subtitulo mt-5">Circulares</h1>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- <h4 class="subtitulo2 mt-3">Circular número PF/005/2019 </h4>  -->
                    <a :href="urlServe+'marco-juridico/Estatal/informacion/Circulares/PF-005-2019.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Circular número PF/005/2019 </h5>
                                </div>
                                <div class="col-4">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <h1 class="subtitulo mt-5">Reglamentos y Lineamientos</h1>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <div class="accordion mt-4" id="accordionExample2">
                        <!-- Reglamentos -->
                        <div class="card">
                            <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapseReglamento" style="display:flex; justify-content:space-between;">
                                <span>Reglamentos</span>
                                <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                            </div>

                            <div id="collapse1" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample2">
                            <div class="card-body">
                                <UL>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Func-Adquisiciones.pdf'" target="_blank">Reglamento de Funcionamiento del Subcomité de Adquisiciones, Arrendamiento de Bienes Muebles y Contratación de Servicios</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Ley-Proyectos.pdf'" target="_blank">Reglamento de Ley de Proyectos de Prestación de Servicios del Estado de Chiapas</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Codigo.pdf'" target="_blank">Reglamento del Código de la Hacienda Pública para el Estado de Chiapas</A> </LI>
                                    <LI><A :href="urlServe+'conocenos/informacion/reglamento-interior/Reglamento-interior.pdf'" target="_blank">Reglamento Interior de la Secretaría de Hacienda</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Ley-Planeacion.pdf'" target="_blank">Reglamento de la Ley de Planeación para el Estado de Chiapas</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Coplade.pdf'" target="_blank">Reglamento del Comité de Planeación para el Desarrollo</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Reglamentos/Ley-Adquisiciones.pdf'" target="_blank">Reglamento de la Ley de Adquisiciones, Arrendamiento de Bienes Muebles y Contratación de Servicios para el Estado de Chiapas</A> </LI>
                                </UL>
                            </div>
                            </div>
                        </div>
                        <!-- Lineamientos generales -->
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <h2 class="mb-0">
                                    <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapseLineamientos" style="display:flex; justify-content:space-between;">
                                    <span>Lineamientos Generales</span>
                                    <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                    </button>
                                </h2>
                            </div>
                            <div id="collapse2" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample2">
                            <div class="card-body">
                                <UL>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales//lineam-materia-adquisiciones.pdf'" target="_blank">Lineamientos en materia de adquisiciones, Arrendamiento de Bienes Muebles y Contratación de Servicios para el Ejercicio Fiscal 2022</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineami-Ingresos-Propios.pdf'" target="_blank">Lineamientos para el registro presupuestario, contable y financiero de los ingresos propios que generen los Organismos Públicos</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-Eval-RH.pdf'" target="_blank">Lineamientos Para la Evaluación y Formación de los Recursos Humanos de la Administración Pública Estatal </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-Grale-Estructura-Organicas.pdf'" target="_blank">Lineamientos Generales que Regulan los Movimientos de Estructuras Orgánicas y Plantilla de Plazas de la Administración Pública Estatal </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-Movimientos-Nominales.pdf'" target="_blank">Lineamientos para la Aplicación de Movimientos Nominales y Administración de Plazas del Personal de la Administración Pública Estatal</A> </LI>
                                    <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Plaza-Vac-Fallecim.pdf'" target="_blank">Lineamientos para el otorgamiento de la Plaza Vacante por Fallecimiento de los Trabajadores de Base Agremiados al Sindicato de Trabajadores al Servicio del Estado de Chiapas</a></li>
                                    <!-- <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Plaza-Vac-Fallecim-Fe-Erratas.pdf'" target="_blank">FE DE ERRATAS de los Lineamientos para el otorgamiento de la plaza vacante por fallecimiento de los trabajadores agremiados al Sindicato de Trabajadores al Servicio del Estado de Chiapas</a></li> -->
                                    <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Becas-Trab-Sindica.pdf'" target="_blank">Lineamientos para el otorgamiento de becas a trabajadores e hijos de trabajadores sindicalizados </a></li>
                                    <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Emision-Recon-Pension.pdf'" target="_blank">Lineamientos para la Emisión de Reconocimientos de Antigüedad Laboral, Licencias, Dictámenes de Pensión y Pago de Marcha y Funeral </a></li>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Extincion-Fideicomisos.pdf'" target="_blank">Lineamientos para la Extinción de los Fideicomisos Públicos del Estado de Chiapas </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/TdR1-31-Julio-2014.pdf'" target="_blank">TdR1: Términos de Referencia para la Evaluación de Consistencia y Resultados </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Fideicomisos-publicos-estatales.pdf'" target="_blank">Lineamientos Generales para los Fideicomisos Públicos Estatales </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Organos-de-Gob-Entidades-Paraestatales.pdf'" target="_blank">Lineamientos generales para el funcionamiento de los órganos de Gobierno de las Entidades Paraestatales </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Metodologia_Marco_Logico.pdf'" target="_blank">Metodologia del Marco Lógico</A> </LI>
                                </UL>


                                <UL>
                                    <LI><A href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/informacion/Lineamientos/Generales/PADA.pdf" target="_blank">Plan Anual de Desarrollo Archivístico (PADA) de la Secretaría de Hacienda 2021</A> </LI>

                                    <LI><A href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2023.pdf" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2023</A> </LI>
                                    <LI><A href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2022.pdf" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2022</A> </LI>
                                    <LI><A href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2021.pdf" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2021</A> </LI>
                                    <LI><A href="http://www.haciendachiapas.gob.mx/marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2020.pdf" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2020</A> </LI>

                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2019.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2019</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2018.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2018</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2017.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2017</A> </LI>
                                </UL>
                                <TABLE width="95%" align="center">
                                    <TR>
                                    <TD width="8%"></TD>
                                    <TD>
                                        <UL>
                                            <LI><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Anexo_PAE_2017.pdf'" target="_blank">Anexo del PAE 2017  </a></LI>
                                        </UL>
                                    </TD>
                                    </TR>
                                </TABLE>

                                <UL>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2016.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2016</A> </LI>
                                </UL>
                                <TABLE width="95%" align="center">

                                    <TR>
                                    <TD width="8%"></TD>
                                    <TD>
                                    <UL>
                                        <LI><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Anexo_PAE_2016.pdf'" target="_blank">Anexo del PAE 2016  </a></LI>
                                    </UL>
                                    </TD>
                                    </TR>
                                </TABLE>

                                <UL>
                                    <LI>
                                        <A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion_2015.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2015</A>
                                    </LI>
                                </UL>

                                <TABLE width="95%" align="center">
                                    <TR>
                                        <TD width="8%"></TD>
                                        <TD>
                                            <UL>
                                                <LI><a :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Anexo_PAE_2015.pdf'" target="_blank">Anexo del PAE 2015 </a></LI>
                                            </UL>
                                        </TD>
                                    </TR>
                                </TABLE>


                                <UL>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Prog_Anual_Evaluacion.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2014</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/PAE_ramo_33.pdf'" target="_blank">Programa Anual de Evaluación del Estado de Chiapas para el Ejercicio Fiscal 2013 </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Fondo.PDF'" target="_blank">Para la Utilización del Fondo de Desastres Naturales</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Formulacion-Programas.pdf'" target="_blank">Para la Formulación de Programas Institucionales</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Plan-Desarrollo.pdf'" target="_blank">Para Integrar el Plan de Desarrollo Chiapas Solidario 2007-2012</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Actualizacion.pdf'" target="_blank">Para la Actualización de los Programas Sectoriales y Especiales 2010-2012</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-Grales-Austeridad.pdf'" target="_blank">Lineamientos Generales de Austeridad, Racionalidad y Disciplina del Gasto de los Organismos Públicos de la Administración Pública Estatal </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-Grales-RH.pdf'" target="_blank">Lineamientos Generales para la Administración de los Recursos Humanos Adscritos a la Administración Pública Estatal </A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Guia.pdf'" target="_blank">Guía Técnica Metodológica "Reforma en Política Presupuestaria"</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-ASM-2017.pdf'" target="_blank">Mecanismos de Seguimiento a los Aspectos Susceptibles de Mejora (ASM) 2017</A> </LI>
                                    <LI><A :href="urlServe+'marco-juridico/Estatal/informacion/Lineamientos/Generales/Lineam-ASM-2018.pdf'" target="_blank">Mecanismos de Seguimiento a los Aspectos Susceptibles de Mejora (ASM) 2018</A> </LI>
                                </UL>
                            </div>
                            </div>
                        </div>
                        <!-- <lineamientos-collapse></lineamientos-collapse> -->

                    </div>
                    <!-- Aqui va el componenete de lineamientos -->
                    <lineamientos-collapse></lineamientos-collapse>


            <!--  -->

            <!--  -->
                </div>
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes img_fija">
                        <div class="sec_imagen">
                            <img src="@/assets/imagenes/reglas.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-aviso my-5">
            <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
import lineamientosCollapse from './reglamentos-lineamientos/lineamientos-desaProgramática-collapse.vue';
export default {
    components:{
        atrasComponent,
        lineamientosCollapse,
        botonAtras
    },
    data: function(){
        return{
            selected: 'Consultar año',
        }
    },
     methods:{

     },
     mounted(){
        window.scrollTo(0, 0);
    },
}
</script>

<style scoped>

.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

li{
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
